import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { setupSentry } from './utils/sentry';
import injectGlobals from './utils/inject-globals';
import { initializeCrossAppCache } from './utils/cross-app-cache';
import { selectSessionForMasq } from './utils/masq';
import { router } from './router';
import { installLinkPrefetching } from './services/router/prefetch';
import { registerSessionInvalidationRedirect } from './services/session/invalidation-redirect';
import { installRum } from './services/rum';
import './index.scss';

setupSentry();
installRum(router);
initializeCrossAppCache();
injectGlobals();
selectSessionForMasq();
installLinkPrefetching();
registerSessionInvalidationRedirect();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement, { identifierPrefix: 'hydra_' }).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
